<template>
  <template v-if="info.status === 'edit'">
    <select-remote-multi
        v-if="widget.multi"
        v-model="multiValue"
        :title="info.title"
        :widget="widget"
    />
    <select-remote
        v-else
        :title="info.title"
        :widget="widget"
        v-model="data[propName]"
    />
  </template>
  <template v-else>
    <select-remote-table :data="data" v-bind="$props"/>
  </template>
</template>

<script lang="ts" setup>
import { computed, defineProps } from 'vue';
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer"
import {ScForm} from "@/models/ScForm";
import SelectRemote from "@/components/business/crud/common/SelectRemote.vue";
import SelectRemoteTable from "./SelectRemoteTable.vue";
import {SelectRemoteFieldType} from "@/components/business/crud/interface/FieldType";
import SelectRemoteMulti from "@/components/business/crud/common/SelectRemoteMulti.vue";

const props = defineProps<{
  propName: string;
  widget: SelectRemoteFieldType;
  info: WidgetInfo;
}>();

const data = ScForm.useFormData();

const multiValue = computed({
  get: ()=> {
    return data.value[props.propName]?.list
  },
  set:(value) => {
    if (!data.value[props.propName]?.list) {
      data.value[props.propName] = {}
    }
    data.value[props.propName].list = value;
  }
})

</script>

<style lang="scss" scoped>
.notfound {
  display: flex;
  flex-direction: row;
  //justify-content: center;
  align-items: center;
  height: 60px;
}
</style>
